module.exports = __webpack_public_path__ + "img/colored-rounded.fcbe244c.svg";